import { ProductKeys3P, ProductResourceTypes3P } from '../common/ui/configs/types';

/**
 * Static mapping from ProductResourceTypes3P to ProductKeys3P.
 * Allows looking up the product key for a given resource type.
 * NOTE: This does not include `Loom` as it does not have a `resourceType`.
 */
export const ResourceTypeToProductKeyMap: Map<ProductResourceTypes3P, ProductKeys3P> = new Map<
	ProductResourceTypes3P,
	ProductKeys3P
>([
	[ProductResourceTypes3P.AtlassianWebCrawler, ProductKeys3P.AtlassianWebCrawler],
	[ProductResourceTypes3P.Figma, ProductKeys3P.Figma],
	[ProductResourceTypes3P.Github, ProductKeys3P.Github],
	[ProductResourceTypes3P.GoogleDrive, ProductKeys3P.GoogleDrive],
	[ProductResourceTypes3P.OneDrive, ProductKeys3P.OneDrive],
	[ProductResourceTypes3P.Dropbox, ProductKeys3P.Dropbox],
	[ProductResourceTypes3P.Slack, ProductKeys3P.Slack],
	[ProductResourceTypes3P.Sharepoint, ProductKeys3P.Sharepoint],
	[ProductResourceTypes3P.Teams, ProductKeys3P.Teams],
	[ProductResourceTypes3P.GoogleCalendar, ProductKeys3P.GoogleCalendar],
	[ProductResourceTypes3P.OutlookCalendar, ProductKeys3P.OutlookCalendar],
	[ProductResourceTypes3P.OutlookMail, ProductKeys3P.OutlookMail],
	[ProductResourceTypes3P.Gmail, ProductKeys3P.Gmail],
	[ProductResourceTypes3P.AdobeSign, ProductKeys3P.AdobeSign],
	[ProductResourceTypes3P.Asana, ProductKeys3P.Asana],
	[ProductResourceTypes3P.Zendesk, ProductKeys3P.Zendesk],
	[ProductResourceTypes3P.Airtable, ProductKeys3P.Airtable],
	[ProductResourceTypes3P.Smartsheet, ProductKeys3P.Smartsheet],
	[ProductResourceTypes3P.Notion, ProductKeys3P.Notion],
	[ProductResourceTypes3P.Miro, ProductKeys3P.Miro],
	[ProductResourceTypes3P.Docusign, ProductKeys3P.Docusign],
	[ProductResourceTypes3P.Lucid, ProductKeys3P.Lucid],
	[ProductResourceTypes3P.Monday, ProductKeys3P.Monday],
	[ProductResourceTypes3P.AzureDevops, ProductKeys3P.AzureDevops],
	[ProductResourceTypes3P.Gitlab, ProductKeys3P.Gitlab],
	[ProductResourceTypes3P.ConfluenceDC, ProductKeys3P.ConfluenceDC],
	[ProductResourceTypes3P.JiraDC, ProductKeys3P.JiraDC],
	[ProductResourceTypes3P.JsmDC, ProductKeys3P.JsmDC],
	[ProductResourceTypes3P.Canva, ProductKeys3P.Canva],
	[ProductResourceTypes3P.Box, ProductKeys3P.Box],
	[ProductResourceTypes3P.Gong, ProductKeys3P.Gong],
	[ProductResourceTypes3P.Zoom, ProductKeys3P.Zoom],
	[ProductResourceTypes3P.Zeplin, ProductKeys3P.Zeplin],
	[ProductResourceTypes3P.ServiceNow, ProductKeys3P.ServiceNow],
	[ProductResourceTypes3P.Freshservice, ProductKeys3P.Freshservice],
	[ProductResourceTypes3P.PowerBI, ProductKeys3P.PowerBI],
	[ProductResourceTypes3P.ClickUp, ProductKeys3P.ClickUp],
	[ProductResourceTypes3P.Amplitude, ProductKeys3P.Amplitude],
	[ProductResourceTypes3P.Stripe, ProductKeys3P.Stripe],
	[ProductResourceTypes3P.AdobeXD, ProductKeys3P.AdobeXD],
	[ProductResourceTypes3P.Aha, ProductKeys3P.Aha],
	[ProductResourceTypes3P.Mural, ProductKeys3P.Mural],
	[ProductResourceTypes3P.Webex, ProductKeys3P.Webex],
	[ProductResourceTypes3P.Todoist, ProductKeys3P.Todoist],
	[ProductResourceTypes3P.PagerDuty, ProductKeys3P.PagerDuty],
	[ProductResourceTypes3P.Pipedrive, ProductKeys3P.Pipedrive],
	[ProductResourceTypes3P.Hubspot, ProductKeys3P.Hubspot],
	[ProductResourceTypes3P.Dovetail, ProductKeys3P.Dovetail],
	[ProductResourceTypes3P.LaunchDarkly, ProductKeys3P.LaunchDarkly],
	[ProductResourceTypes3P.Salesforce, ProductKeys3P.Salesforce],
	[ProductResourceTypes3P.Sentry, ProductKeys3P.Sentry],
	[ProductResourceTypes3P.Gitbook, ProductKeys3P.Gitbook],
	[ProductResourceTypes3P.AWSS3, ProductKeys3P.AWSS3],
	[ProductResourceTypes3P.Databricks, ProductKeys3P.Databricks],
	[ProductResourceTypes3P.ForgeAdamVitareqDev, ProductKeys3P.ForgeAdamVitareqDev],
	[ProductResourceTypes3P.ForgeAdamVitareqProd, ProductKeys3P.ForgeAdamVitareqProd],
	[ProductResourceTypes3P.ForgeK15tScrollSitesDev, ProductKeys3P.ForgeK15tScrollSitesDev],
	[ProductResourceTypes3P.ForgeK15tScrollSitesProd, ProductKeys3P.ForgeK15tScrollSitesProd],
	[ProductResourceTypes3P.ForgePioAwsDev, ProductKeys3P.ForgePioAwsDev],
	[ProductResourceTypes3P.ForgePioAwsProd, ProductKeys3P.ForgePioAwsProd],
	[ProductResourceTypes3P.ForgePioClickupDev, ProductKeys3P.ForgePioClickupDev],
	[ProductResourceTypes3P.ForgePioClickupProd, ProductKeys3P.ForgePioClickupProd],
	[ProductResourceTypes3P.ForgePioGitbookDev, ProductKeys3P.ForgePioGitbookDev],
	[ProductResourceTypes3P.ForgePioGitbookProd, ProductKeys3P.ForgePioGitbookProd],
	[ProductResourceTypes3P.ForgePioGithubDev, ProductKeys3P.ForgePioGithubDev],
	[ProductResourceTypes3P.ForgePioGithubProd, ProductKeys3P.ForgePioGithubProd],
	[ProductResourceTypes3P.ForgePioGitlabDev, ProductKeys3P.ForgePioGitlabDev],
	[ProductResourceTypes3P.ForgePioGitlabProd, ProductKeys3P.ForgePioGitlabProd],
	[ProductResourceTypes3P.ForgePioGoogleDriveDev, ProductKeys3P.ForgePioGoogleDriveDev],
	[ProductResourceTypes3P.ForgePioGoogleDriveProd, ProductKeys3P.ForgePioGoogleDriveProd],
	[ProductResourceTypes3P.ForgePioGuruDev, ProductKeys3P.ForgePioGuruDev],
	[ProductResourceTypes3P.ForgePioGuruProd, ProductKeys3P.ForgePioGuruProd],
	[ProductResourceTypes3P.ForgePioHelpjuiceDev, ProductKeys3P.ForgePioHelpjuiceDev],
	[ProductResourceTypes3P.ForgePioHelpjuiceProd, ProductKeys3P.ForgePioHelpjuiceProd],
	[ProductResourceTypes3P.ForgePioHubspotDev, ProductKeys3P.ForgePioHubspotDev],
	[ProductResourceTypes3P.ForgePioHubspotProd, ProductKeys3P.ForgePioHubspotProd],
	[ProductResourceTypes3P.ForgePioSalesforceDev, ProductKeys3P.ForgePioSalesforceDev],
	[ProductResourceTypes3P.ForgePioSalesforceProd, ProductKeys3P.ForgePioSalesforceProd],
	[ProductResourceTypes3P.ForgePioSharepointDev, ProductKeys3P.ForgePioSharepointDev],
	[ProductResourceTypes3P.ForgePioSharepointProd, ProductKeys3P.ForgePioSharepointProd],
	[ProductResourceTypes3P.ForgePioStackOverflowDev, ProductKeys3P.ForgePioStackOverflowDev],
	[ProductResourceTypes3P.ForgePioStackOverflowProd, ProductKeys3P.ForgePioStackOverflowProd],
	[ProductResourceTypes3P.ForgeUtoolityGitbookDev, ProductKeys3P.ForgeUtoolityGitbookDev],
	[ProductResourceTypes3P.ForgeUtoolityGitbookProd, ProductKeys3P.ForgeUtoolityGitbookProd],
	[ProductResourceTypes3P.ForgeGdriveEugeneTestDev, ProductKeys3P.ForgeGdriveEugeneTestDev],
	[ProductResourceTypes3P.ForgeGdriveEugeneTestProd, ProductKeys3P.ForgeGdriveEugeneTestProd],
	[ProductResourceTypes3P.ForgeUnitoSalesforceDev, ProductKeys3P.ForgeUnitoSalesforceDev],
	[ProductResourceTypes3P.ForgeUnitoSalesforceProd, ProductKeys3P.ForgeUnitoSalesforceProd],
	[ProductResourceTypes3P.ForgeUnitoServicenowDev, ProductKeys3P.ForgeUnitoServicenowDev],
	[ProductResourceTypes3P.ForgeUnitoServicenowProd, ProductKeys3P.ForgeUnitoServicenowProd],
	[ProductResourceTypes3P.ForgeUnitoWrikeDev, ProductKeys3P.ForgeUnitoWrikeDev],
	[ProductResourceTypes3P.ForgeUnitoWrikeProd, ProductKeys3P.ForgeUnitoWrikeProd],
	[ProductResourceTypes3P.ForgeUnitoAsanaDev, ProductKeys3P.ForgeUnitoAsanaDev],
	[ProductResourceTypes3P.ForgeUnitoAsanaProd, ProductKeys3P.ForgeUnitoAsanaProd],
	[ProductResourceTypes3P.ForgeUnitoBasecampDev, ProductKeys3P.ForgeUnitoBasecampDev],
	[ProductResourceTypes3P.ForgeUnitoBasecampProd, ProductKeys3P.ForgeUnitoBasecampProd],
]);
